import React from "react";

import styled from "@emotion/styled";

import { formatNumber } from "../../../../../utils/NumberHelpers";
import {
    iShopwareCalculatedPrice,
    iShopwareCartListPrice,
} from "../../ShoppingCart/store";
import { iShopwareProductCalculatedCheapestPrice } from "../../store";

interface iProductPriceProps {
    price: iShopwareProductCalculatedCheapestPrice | iShopwareCalculatedPrice;
}

const Price = styled.span`
    font-size: 1.5rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.red.toString()};
`;

/**
 * Shows the Price and displays the list price (crossed out) if the product is on a discount.
 * @param price
 * @constructor
 */
const ProductPrice = ({ price }: iProductPriceProps) => {
    return (
        <div>
            <ListPrice listPrice={price.listPrice} />
            <Price>{formatNumber(price.totalPrice.toFixed(2))} € *</Price>
        </div>
    );
};

const ListPriceContainer = styled.div`
    display: flex;
    gap: 0.3em;
    font-size: 1rem;
`;

const CrossedOutPrice = styled.span`
    margin-bottom: 0.25em;
    text-decoration: line-through;
`;

const DiscountIndicator = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2em;
    height: 1.2em;
    color: ${({ theme }) => theme.colors.white.toString()};
    text-align: center;
    background-color: ${({ theme }) => theme.colors.red.toString()};

    ::after {
        content: "%";
    }
`;

interface iListPriceProps {
    listPrice: iShopwareCartListPrice | null;
}
const ListPrice = ({ listPrice }: iListPriceProps) => {
    if (!listPrice) {
        return null;
    }

    return (
        <ListPriceContainer>
            <DiscountIndicator />
            <CrossedOutPrice>
                {formatNumber(listPrice.price.toFixed(2))} € *
            </CrossedOutPrice>
            ({formatNumber(listPrice.percentage.toFixed(2))} % gespart)
        </ListPriceContainer>
    );
};

export default ProductPrice;
